import { render, staticRenderFns } from "./BaseDropdown.vue?vue&type=template&id=4e755592&scoped=true"
import script from "./BaseDropdown.vue?vue&type=script&lang=js"
export * from "./BaseDropdown.vue?vue&type=script&lang=js"
import style0 from "./BaseDropdown.vue?vue&type=style&index=0&id=4e755592&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e755592",
  null
  
)

export default component.exports